import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
// Styles
import "./schoolAdmin.css";
// Material Ui
import MaterialTable from "material-table";
import { CircularProgress, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  FaTimes,
  FaPen,
  FaKey,
  FaTrash,
  FaAngleRight,
  FaAngleDown,
} from "react-icons/fa";
import successimg from "../../assets/images/successimg.png";
import { BsXLg } from "react-icons/bs";
// Services
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Assets
import menuthree from "../../assets/images/menuthree.png";
import ErrorMessage from "../../Common/ErrorMessage";
import moment from "moment";
import SchoolStatus from "./SchoolAdminPages/SchoolStatus/SchoolStatus";
import PageNotFound from "../../routes/PageNotFound";
import PatchedPagination from "../../Common/PatchedPagination";
import { connect } from "react-redux";
import { permissionNames, userRoles } from "../../utils/constant";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import LongMenu from "../../Common/actionMenu";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteDialog from "./Popups/DeleteDialog";
import SuccessDialog from "./Popups/SuccessDialog";
import CustomSearch from "../../Common/CustomSearch";
import { formatPhoneNumber } from "../../utils";
import ButtonWithToolTip from "../../Common/ButtonWithToolTip";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

// All Urls

class SchoolCoaches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
      columns: [],
      deleteId: null,
      anchorEl: null,
      total: null,
      submitting: false,
      schoolId: getFromLocalStorage("schoolId"),
      emailToReset: "",
      redirect: false,
      manage_menu_three_dots: "manage-menu-three-dots",
      currentRowId: "",
      coach: "",
      selected: "Select Sport",
      isActive: false,
      filterSports: [],
      notFound: false,
      assignedRights: [],
      userRole: "",
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      redirectToRow: false,
      searchQuery: "",
      searchedRecord: false,
      deletePopup: false,
      msg: "",
      currentAthleteId: "",
      successPopup: false,
      recordNotFound: false,
    };
  }

  options = ["Football ", "Athlete ", "Cricket "];

  //pop ups
  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }
  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  openDialogWrong() {
    this.setState({ openWrong: !this.state.openWrong });
  }
  closeDialogWrong() {
    this.setState({ openWrong: !this.state.openWrong });
  }

  openDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }
  closeDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
    this.getAllCoachesByPage(
      this.state.pageState.page,
      this.state.pageState.pageSize
    );
  }

  openDialogResetPassword = (email) => {
    this.setState({ openResetPopUp: !this.state.openResetPopUp });
    var emailToReset = email;
    this.setState({ emailToReset });
  };
  closeDialogResetPassword() {
    this.setState({ openResetPopUp: !this.state.openResetPopUp });
  }

  openDialogSuccessReset() {
    this.setState({ openSuccessReset: !this.state.openSuccessReset });
  }
  closeDialogSuccessReset() {
    this.setState({ openSuccessReset: !this.state.openSuccessReset });
  }

  ConfirmResetPassword() {
    userService
      .forgotPassword(this.state.emailToReset)
      .then((response) => {
        this.openDialogSuccessReset();
        this.closeDialogResetPassword();
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  componentDidMount() {
    const coachone = document.getElementById("Coach");
    const { schoolId } = this.state;
    if (coachone) {
      coachone.classList.add("btnActive");
    }
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const userRole = this.props.userRole;

    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    this.setState({
      assignedRights: assignedRightsIds,
      userRole,
      submitting: true,
    });
    this.getFilterSports(schoolId);
    this.getAllCoachesByPage(
      this.state.pageState.page,
      this.state.pageState.pageSize
    );
  }

  getAllCoachesByPage = (page, size) => {
    const { schoolId, recordNotFound } = this.state;
    this.setState({ pageState: { ...this.state.pageState, isLoading: true } });
    userService
      .getAllCoachesByPage(schoolId, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.coaches,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ submitting: false });
      });
  };

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = () => {
    this.setState({
      allSchoolList: [],
      columns: [],
      deleteId: null,
      anchorEl: null,
      open: false,
      modalId: "",
    });
  };

  getdeleteID(id) {
    let arr = [];
    arr.push(id);
    this.deleteId = arr;
  }

  deleteCoach() {
    const ids = this.state.modalId;
    const id = {
      ids: [ids],
    };
    userService
      .deleteCoachById(id)
      .then((response) => {
        if (response.status === 200) {
          this.openDialogRemoved();
          this.getSchoolData();
        } else {
          this.openDialogWrong();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getSchoolData(option) {
    this.setState({
      submitting: true,
      notFound: false,
    });
    let schoolId = getFromLocalStorage("schoolId");
    userService
      .getAllCoachesByFilter(schoolId, option)
      .then((response) => {
        if (response.data.status === true) {
          var allSchoolList = response.data.data.coaches;
          const total = response.data.data.total;
          this.setState({ allSchoolList, total, submitting: false });
        } else {
          this.setState({ notFound: true, submitting: false });
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  openDialog = (id) => {
    this.setState({
      open: !this.state.open,
      modalId: id,
    });
  };

  closeDialog = () => {
    this.setState({ open: !this.state.open });
    // this.deleteCoach();
  };

  ConfirmcloseDialog = () => {
    this.setState({ open: !this.state.open });
    this.deleteCoach();
  };
  handleDropdownChange = (event) => {
    this.setState({ coach: event.target.value });
  };

  filterTable = (option) => {
    this.getSchoolData(option);
    this.setState({ selected: option, isActive: false });
  };

  getFilterSports(schoolId) {
    userService
      .getSports(schoolId)
      .then((response) => {
        if (response.data.status === true) {
          const filterSports = response.data.data;
          this.setState({ filterSports });
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  searchCoaches = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchCoaches(query, schoolId, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.coaches,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound: res.data.data.coaches.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  closeAthleteDeleteDialog = () => {
    this.setState({ deletePopup: false });
  };

  deleteCurrentAthlete = () => {
    const { searchedRecord, searchQuery, pageState } = this.state;
    this.deleteAthleteUsingId().then(() => {
      this.setState({
        msg: "Coach Removed Successfully",
        successPopup: true,
        deletePopup: false,
      });
      if (searchedRecord) {
        this.searchCoaches(searchQuery, pageState.page, 10);
      } else {
        this.getAllCoachesByPage(pageState.page, 10);
      }
    });
  };

  deleteAthleteUsingId = () => {
    const id = {
      ids: [this.state.currentAthleteId],
    };
    return userService.deleteCoachById(id);
  };

  deleteAthleteDialog = (id) => {
    this.setState({
      deletePopup: true,
      msg: "Are You Sure You Want to Remove this Athlete?",
      currentAthleteId: id,
    });
  };

  toggleSuccessDialog = () => {
    const { successPopup } = this.state;
    this.setState({ successPopup: !successPopup });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  render() {
    const {
      allSchoolList,
      open,
      openResetPopUp,
      redirect,
      userRole,
      assignedRights,
      currentRowId,
      isActive,
      selected,
      filterSports,
      notFound,
      openRemove,
      openWrong,
      openSuccessReset,
      submitting,
      pageState,
      redirectToRow,
      searchQuery,
      searchedRecord,
      msg,
      successPopup,
      deletePopup,
      recordNotFound,
    } = this.state;
    const { history, currentSeason } = this.props;
    const { isDrawerOpen } = this.props;

    if (redirectToRow) {
      history.push(`/coachesdetails/${currentRowId}`);
    }

    const tableColumns = [
      {
        field: "firstName",
        headerName: "Name",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 200,
        cellClassName: "custom-cell",
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100">
            <p className="link-blue text-width-auto mg-auto">
              {params.row.firstName + " " + params.row.lastName}
            </p>
          </div>
        ),
      },
      {
        field: "email",
        headerName: "Email",
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        flex: 1,
        minWidth: 250,
      },
      {
        field: "signUpDate",
        headerName: "Signup-Date",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
      },
      {
        field: "specialty",
        headerName: "Speciality",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "phoneNumber",
        headerName: "Phone Number",
        flex: 1,
        minWidth: 180,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <p>{formatPhoneNumber(params.row.phoneNumber)}</p>
        ),
      },
      {
        field: "status",
        headerName: "Status",
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index",
        align: "center",
        width: 150,
        headerAlign: "center",
        renderCell: (params) => (
          <SchoolStatus
            status={params.row.user.active}
            isDeleted={params.row.user.deleted}
          />
        ),
      },
      {
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index2",
        headerAlign: "center",
        align: "center",
        sortable: false,
        height: 100,
        renderCell: (params) => (
          <div>
            {userRole === userRoles.ROLE_SCHOOL_ADMIN ||
            assignedRights.includes(permissionNames.Add_Remove_Coaches) ? (
              <LongMenu
                rowData={params.row}
                openDialogResetPassword={this.openDialogResetPassword}
                openDialog={this.deleteAthleteDialog}
                navigationLink="editCoaches"
              />
            ) : null}
          </div>
        ),
      },
    ];

    return (
      <div>
        <div>
          {userRole === userRoles.ROLE_TEAM_ADMIN ||
          userRole === userRoles.ROLE_SCHOOL_ADMIN ||
          userRole === userRoles.ROLE_COACH ? (
            <div
              className={
                isDrawerOpen
                  ? "content-layout p-0"
                  : "toggle-content-layout p-0"
              }
            >
              <SchoolAdminDashboard />
              <div className="mng-header stickyy">
                <h4 className="fs-24 bold mob-hd">
                  {selected === "Select Sport" ? "Coaches" : selected} (
                  {allSchoolList.length !== null &&
                  notFound === false &&
                  !submitting
                    ? pageState.total
                    : "0"}
                  )
                </h4>

                <div className="d-flex align-items-center ">
                  <div className="hide-dropdn mx-3 text-right dropdown-coach d-hide">
                    <div
                      onClick={(e) => this.setState({ isActive: !isActive })}
                      className={
                        isActive ? "dropdown-btn-active" : "dropdown-btn"
                      }
                    >
                      {selected}
                      {isActive ? (
                        <FaAngleDown className="dropIcon" />
                      ) : (
                        <FaAngleRight className="dropIcon" />
                      )}
                    </div>
                    {isActive && (
                      <div name="Select Name" className="dropdownContent">
                        <div className="dropdownContent-outer-div">
                          {filterSports.map((option, index) => (
                            <div
                              key={index}
                              onClick={() => this.filterTable(option.sportName)}
                              className="dropdownItem"
                            >
                              {option.sportName}
                            </div>
                          ))}
                          <div
                            name="all sport"
                            value="All Sport"
                            onClick={(e) => this.filterTable("Select Sport")}
                            className="dropdownItem"
                          >
                            All Sport
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {(userRole === userRoles.ROLE_SCHOOL_ADMIN ||
                    assignedRights.includes("Add / Remove Coaches")) &&
                  currentSeason ? (
                    <Link to="/addschoolcoaches">
                      <button className="addBtnn2 mng-padding">
                        <AddIcon className="mr-2 addIconSc " />
                        {""}Add Coach
                      </button>
                    </Link>
                  ) : (
                    <ButtonWithToolTip
                      buttonText="Add Coach"
                      toolTipText={`${
                        !currentSeason
                          ? "Please Create New Season Before Adding Coach."
                          : "You Don't Have Permission To Add Coach."
                      }`}
                    />
                  )}
                </div>
              </div>
              <div className="hide-dropdn-sm dropdown-coach d-hide">
                <div
                  onClick={(e) => this.setState({ isActive: !isActive })}
                  className={isActive ? "dropdown-btn-active" : "dropdown-btn"}
                >
                  {selected}
                  {isActive ? <FaAngleDown /> : <FaAngleRight />}
                </div>
                {isActive && (
                  <div name="Select Name" className=" dropdownContent">
                    {filterSports.map((option, index) => (
                      <div
                        key={index}
                        onClick={(e) => this.filterTable(option.sportName)}
                        className="dropdownItem"
                      >
                        {option.sportName}
                      </div>
                    ))}
                    <div
                      name="all sport"
                      value="All Sport"
                      onClick={(e) => this.filterTable("Select Sport")}
                      className="dropdownItem"
                    >
                      All Sport
                    </div>
                  </div>
                )}
              </div>

              {submitting && (
                <div className="content-layout-loading-animation">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr dynamic-height">
                {!submitting &&
                  (pageState.data.length > 0 || recordNotFound) && (
                    <Paper className="pad-top-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={this.setSearchQuery}
                        setSearchedRecord={this.setSearchedRecord}
                        searchedRecord={searchedRecord}
                        getDataByPage={this.getAllCoachesByPage}
                        pageState={pageState}
                        searchData={this.searchCoaches}
                        setRecordNotFound={this.setRecordNotFound}
                      />
                      <DataGrid
                        rows={pageState.data}
                        rowCount={pageState.total}
                        loading={pageState.isLoading}
                        pagination
                        page={pageState.page}
                        columns={tableColumns}
                        pageSize={pageState.pageSize}
                        rowsPerPageOptions={[10]}
                        paginationMode="server"
                        onPageChange={(newPage) => {
                          if (searchQuery == "") {
                            this.getAllCoachesByPage(newPage, 10);
                          } else {
                            this.searchCoaches(searchQuery, newPage, 10);
                          }
                          this.setState({ ...pageState, page: newPage });
                        }}
                        onPageSizeChange={(newPageSize) =>
                          this.setState({
                            ...pageState,
                            pageSize: newPageSize,
                          })
                        }
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onCellClick={(param) => {
                          this.setState({
                            redirectToRow: true,
                            currentRowId: param.row.id,
                          });
                        }}
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                      />
                    </Paper>
                  )}
                <div className="clear20"></div>
                {!submitting &&
                  !pageState.data.length > 0 &&
                  !recordNotFound && (
                    <div className="content-layout-loading-animation">
                      <p className="fs-20 bold">No Coach Found</p>
                    </div>
                  )}
              </div>

              <Dialog
                id="dialogBoxWrong"
                className="dialog-style"
                open={openWrong || false}
                onClose={this.closeDialogWrong.bind(this)}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto ">
                      <BsXLg
                        onClick={this.closeDialogWrong.bind(this)}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <p className="fs-20 semi-bold text-center">
                        Something Went Wrong..!
                      </p>
                      <div className="clear10"></div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                      <button
                        type="button"
                        className="donebtn"
                        onClick={this.closeDialogWrong.bind(this)}
                      >
                        DONE
                      </button>
                    </div>
                  </div>

                  <div className="clear10"></div>

                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>
              {/* modal pop up */}

              <Dialog
                id="dialogBox"
                open={openResetPopUp || false}
                onClose={this.closeDialogResetPassword}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto">
                      <FaTimes
                        onClick={() => {
                          this.closeDialogResetPassword();
                        }}
                        className="crossview cp"
                      />
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <p className="fs-20 semi-bold text-center mb-4">
                        Are you sure
                        <br />
                        you want to reset the password?
                      </p>
                    </div>
                    <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
                      <button
                        type="button"
                        className="cancelbtn canBtn nobtn"
                        onClick={() => {
                          this.closeDialogResetPassword();
                        }}
                      >
                        No
                      </button>
                    </div>
                    <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
                      <button
                        type="button"
                        className="yes-btn delBtn"
                        onClick={() => {
                          this.ConfirmResetPassword();
                        }}
                      >
                        Yes, Reset
                      </button>
                    </div>
                  </div>
                  <div className="clear10"></div>
                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>

              <Dialog
                id="dialogBoxRemove"
                open={openSuccessReset || false}
                onClose={this.closeDialogSuccessReset.bind(this)}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto">
                      <FaTimes
                        onClick={this.closeDialogSuccessReset.bind(this)}
                        className="crossview cp"
                      />
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <img
                        src={successimg}
                        alt="success"
                        className="successimg-new"
                      ></img>
                      <p className="fs-20 semi-bold text-center">
                        Password Reset Link Sent Successfully!
                      </p>
                      <div className="clear10"></div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                      <Link to="/schoolcoaches">
                        <button
                          type="button"
                          className="donebtn canBtn"
                          onClick={this.closeDialogSuccessReset.bind(this)}
                        >
                          DONE
                        </button>
                      </Link>
                    </div>
                  </div>

                  <div className="clear10"></div>

                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>

              <DeleteDialog
                open={deletePopup}
                closeDialog={this.closeAthleteDeleteDialog}
                deleteRecord={this.deleteCurrentAthlete}
                deleteId={null}
                msg={msg}
              />

              <SuccessDialog
                successPopUp={successPopup}
                toggleSuccessDialog={this.toggleSuccessDialog}
                msg={msg}
              />
            </div>
          ) : (
            <PageNotFoundPage />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRole: state.loggedInUser.role,
    currentSeason: state.loggedInUser.userProfile.currentSeason,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(connect(mapStateToProps)(SchoolCoaches));
